import BaseModel from '../core/BaseModel'
//import UserModel from '@/models/UserModel'
export default class RentalOrderModel extends BaseModel {

    constructor() {
        super({
                name: "rental_order",
                tableName: 'rental_order',
                label: "rental_order",
                display_key: 'name'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                code: {
                    name: 'code',
                    type: "String",
                    label: 'code',
                    display: false
                },
            })
    }

}